export const validateDataValue = (data?: string, value = ''): string => {
  if (data == null) {
    return value;
  }

  return data?.toString() ?? value;
};
